import {
  getHandledErrors as getMobileLinesHandledErrors,
} from './mobileLines';
import {
  getHandledErrors as getActivateMobileLineHandledErrors,
} from './activateMobileLine';
import {
  getHandledErrors as getXboxGamePassHandledErrors,
} from './xboxGamePass';
import {
  getHandledErrors as getActivateXboxGamePassBonusHandledErrors,
} from './activateXboxGamePassBonus';
import {
  getHandledErrors as getInternetHandledErrors,
} from './internet';
import {
  getHandledErrors as getDevicesHandledErrors,
} from './devices';
import {
  getHandledErrors as getR2RHandledErrors,
} from './r2r';
import {
  getHandledErrors as getPackHandledErrors,
} from './pack';
import {
  getHandledErrors as getTvHandledErrors,
} from './tv';
import {
  getHandledErrors as getFttrHandledErrors,
} from './fttr';
import {
  getHandledErrors as getSubscriptionsHandledErrors,
} from './subscriptions';
import {
  getHandledErrors as getBonusHandledErrors,
} from './bonus';
import {
  getHandledErrors as getEquipmentHandledErrors,
} from './equipment';
import {
  getHandledErrors as getManualHandledErrors,
} from './manual';
import {
  getHandledErrors as getEmployeesHandledErrors,
} from './employees';
import {
  getHandledErrors as getPrepaidHandledErrors,
} from './prepaid';
import {
  getHandledErrors as getMultiSimHandledErrors,
} from './multiSim';
import {
  getHandledErrors as getCarHandledErrors,
} from './car';
import {
  getHandledErrors as getProtectionHandledErrors,
} from './protection';
import {
  getHandledErrors as getESimHandledErrors,
} from './eSim';
import {
  getHandledErrors as getR2RRenewalHandledErrors,
} from './r2rRenewal';
import {
  getHandledErrors as getChangeOTTModalityHandlerErrors,
} from './changeOTTModality';
import {
  getHandledErrors as getDuoHandledErrors,
} from './duo';
import {
  getHandledErrors as getBillinHandledErrors,
} from './billin';
import {
  getHandledErrors as getSpeedChangeHandledErrors,
} from './speedChange';
import {
  getHandledErrors as getR2RAutoRenewalHandledErrors,
} from './r2rAutoRenewal';
import {
  getHandledErrors as getPackR2RHandledErrors,
} from './packR2R';
import {
  getHandledErrors as getMovistarPlusHandledErrors,
} from './movistarPlus';
import { FLOW_TYPES } from '../../../flowDefinition/flowTypes';

export const getHandledErrors = (errorToPrint) => {
  const flowHandledErrors = {
    [FLOW_TYPES.MOBILE_LINES]: getMobileLinesHandledErrors(errorToPrint),
    [FLOW_TYPES.ACTIVATE_MOBILE_LINE]: getActivateMobileLineHandledErrors(errorToPrint),
    [FLOW_TYPES.XBOX_GAME_PASS]: getXboxGamePassHandledErrors(errorToPrint),
    [FLOW_TYPES.ACTIVATE_XBOX_GAME_PASS_BONUS]: getActivateXboxGamePassBonusHandledErrors(errorToPrint),
    [FLOW_TYPES.INTERNET]: getInternetHandledErrors(errorToPrint),
    [FLOW_TYPES.DEVICES]: getDevicesHandledErrors(errorToPrint),
    [FLOW_TYPES.R2R]: getR2RHandledErrors(errorToPrint),
    [FLOW_TYPES.R2R_2]: getR2RHandledErrors(errorToPrint),
    [FLOW_TYPES.PACK]: getPackHandledErrors(errorToPrint),
    [FLOW_TYPES.TV]: getTvHandledErrors(errorToPrint),
    [FLOW_TYPES.FTTR]: getFttrHandledErrors(errorToPrint),
    [FLOW_TYPES.SUBSCRIPTIONS]: getSubscriptionsHandledErrors(errorToPrint),
    [FLOW_TYPES.BONUS]: getBonusHandledErrors(errorToPrint),
    [FLOW_TYPES.EQUIPMENT]: getEquipmentHandledErrors(errorToPrint),
    [FLOW_TYPES.MANUAL]: getManualHandledErrors(errorToPrint),
    [FLOW_TYPES.EMPLOYEES]: getEmployeesHandledErrors(errorToPrint),
    [FLOW_TYPES.PROTECTION]: getProtectionHandledErrors(errorToPrint),
    [FLOW_TYPES.PREPAID]: getPrepaidHandledErrors(errorToPrint),
    [FLOW_TYPES.MULTI_SIM]: getMultiSimHandledErrors(errorToPrint),
    [FLOW_TYPES.CAR]: getCarHandledErrors(errorToPrint),
    [FLOW_TYPES.E_SIM]: getESimHandledErrors(errorToPrint),
    [FLOW_TYPES.R2R_RENEWAL]: getR2RRenewalHandledErrors(errorToPrint),
    [FLOW_TYPES.CHANGE_OTT_MODALITY]: getChangeOTTModalityHandlerErrors(errorToPrint),
    [FLOW_TYPES.DUO]: getDuoHandledErrors(errorToPrint),
    [FLOW_TYPES.BILLIN]: getBillinHandledErrors(errorToPrint),
    [FLOW_TYPES.SPEED_CHANGE]: getSpeedChangeHandledErrors(errorToPrint),
    [FLOW_TYPES.R2R_AUTO_RENEWAL]: getR2RAutoRenewalHandledErrors(errorToPrint),
    [FLOW_TYPES.PACK_R2R]: getPackR2RHandledErrors(errorToPrint),
    [FLOW_TYPES.MOVISTAR_PLUS]: getMovistarPlusHandledErrors(errorToPrint),
  };

  return flowHandledErrors;
};
